/**
 * Type-safe casting helpers for extracting typed values from
 * server config objects (Record<string, unknown>).
 */

export function castToString(value: unknown): string | undefined {
    return typeof value === "string" ? value : undefined;
}

export function castToNumber(value: unknown): number | undefined {
    return typeof value === "number" ? value : undefined;
}

export function castToBoolean(value: unknown): boolean | undefined {
    return typeof value === "boolean" ? value : undefined;
}

export function castToStringArray(value: unknown): string[] {
    return Array.isArray(value) ? value.filter((v): v is string => typeof v === "string") : [];
}
